import React, { useState, useEffect } from 'react';

import { useLanguage } from '../../../helpers/language-context';
import { supabase } from '../../../supabaseClient';

const ArrowRight = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);

const ServiceCard = ({ service }) => {

  const { language } = useLanguage();
  const [isHovered, setIsHovered] = useState(false);

  // Get the appropriate title and description based on current language
  const title = language === 'en' ? service['title-en'] : service['title-my'];
  const description = language === 'en' ? service['description-en'] : service['description-my'];



  return (
    <div
      className="relative h-[450px] rounded-2xl overflow-hidden transition-all duration-300 hover:scale-105"
      style={{
        borderWidth: isHovered ? '3px' : '0px',
        borderStyle: 'solid',
        borderColor: '#FDA729'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        src={service.image}
        alt={title}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

      <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-2xl font-bold">{title}</h3>
          <div
            className={`hidden w-10 h-10 rounded-full bg-[#FDA729] flex items-center justify-center transition-all duration-300 flex-shrink-0 ml-3 cursor-pointer ${isHovered ? 'opacity-100' : 'opacity-0'
              }`}
          >
            <ArrowRight />
          </div>
        </div>
        <p className={`text-sm text-gray-200 transition-all duration-300 ${isHovered ? 'opacity-100 max-h-20' : 'opacity-0 max-h-0'
          } overflow-hidden`}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default function ServicesList() {
  const [services, setServices] = useState([]);
  const { translations } = useLanguage();

  useEffect(() => {
    const fetchServices = async () => {
      const { data, error } = await supabase
        .from('services')
        .select('*')
        .order('id', { ascending: true });
      if (!error) {
        console.log('Fetched services from Supabase:', data);
        setServices(data);
      }
    };
    fetchServices();
  }, []);

  return (
    <section>
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl lg:text-6xl text-[#1e3a8a] mb-16 leading-tight md:w-[60%]">
          {translations.services.missionTitle || "Our Mission Is To Make Your Business Better"}
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <ServiceCard key={index} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
}